import {
  Checkbox,
  CheckboxAsPressable,
  CheckboxTypes,
  VStack,
  HStack,
  CheckboxAccordion,
  Stack,
} from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { Text } from 'native-base';
import React from 'react';

import { getContainerStyles } from './constants';

export declare namespace SectionTypes {
  type SelectionProps = string[];

  type SelectionChange = (
    selections: SelectionProps,
    fieldName: string,
    filterIndex: number
  ) => void;

  interface Props {
    type: 'section';
    fieldName: string;
    filterIndex: number;
    title: string;
    options: CheckboxTypes.Option[];
    onSelectionChange: SelectionChange;
    selection?: SelectionProps;
    optionsColumns?: number;
    onlyOneSelection?: boolean;
    optionWidth?: CheckboxTypes.Props['optionWidth'];
    withScrollableContainer?: boolean;
    scrollablePlaceholder?: string;
    hidden?: boolean;
  }
}

export const hasSectionSelection = (selection: CheckboxTypes.Option['value'][]) =>
  !!selection.length;

export const Section: React.FC<SectionTypes.Props> = ({
  title,
  options,
  fieldName,
  filterIndex,
  onSelectionChange,
  selection,
  onlyOneSelection,
  optionsColumns = 2,
  optionWidth = 150,
  withScrollableContainer = false,
  scrollablePlaceholder = 'Selecione uma opção',
  hidden = false,
}) => {
  const [selections, setSelections] = React.useState<CheckboxTypes.Option['value'][]>(
    selection || []
  );

  const handleSelection = (value: string, selected: boolean) => {
    const newSelections = onlyOneSelection ? [] : [...selections];
    if (selected) {
      newSelections.push(value);
    } else {
      newSelections.splice(newSelections.indexOf(value), 1);
    }
    setSelections([...newSelections]);
    onSelectionChange(newSelections, fieldName, filterIndex);
  };

  const selectionItems = useBreakpointValue({
    base: withScrollableContainer ? (
      <CheckboxAccordion
        placeholder={scrollablePlaceholder}
        options={options}
        onChange={handleSelection}
        selectedValues={selections}
        testId="primary-checkbox-accordion"
      />
    ) : (
      <CheckboxAsPressable
        testID="primary-checkbox-as-pressable"
        options={options}
        selections={selections}
        onPress={handleSelection}
      />
    ),
    lg: (
      <HStack {...getContainerStyles(withScrollableContainer)}>
        <Stack flex={1}>
          <Checkbox
            selectedValues={selections}
            onChange={handleSelection}
            testId="primary-checkbox"
            options={options}
            vertical
            columns={optionsColumns}
            optionWidth={optionWidth}
          />
        </Stack>
      </HStack>
    ),
  });

  if (!options.length || hidden) {
    return <></>;
  }

  return (
    <VStack space="inline.xxxs">
      <Text variant="semibold" fontSize="md" lineHeight="distant">
        {title}
      </Text>
      {selectionItems}
    </VStack>
  );
};
